<template>
  <div>
    <!-- Favorites -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature5"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        Favorite
      </h3>
      <p data-scroll class="mdc-typography--body text-color font-weight-bold">
        ❤ Salvează toate lucrurile care îți plac.😍
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell texture mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content py-5">
            <h6
              class="mdc-typography--headline6 text-color zindex-dropdown position-relative"
              style="z-index:3;"
            >
              Crează, salvează, împarte
            </h6>
            <p class="typography-phrase position-relative" style="z-index:3;">
              <span data-aos="fade" data-aos-duration="300" class="word"
                >Locuri,
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="300"
                class="word"
                >companii,
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="500"
                class="word"
                >startup-uri
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="600"
                class="word"
                >sau școala ta
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="700"
                class="word"
                >preferată
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="800"
                class="word"
                >sunt doar
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="900"
                class="word"
                >la
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1000"
                class="word"
                >o apăsare
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1100"
                class="word"
                >distanță.
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1800"
                class="word"
                >Totul
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1900"
                class="word"
                >devine
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="2000"
                class="word"
                >mai
              </span>
              <span
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="2100"
                class="word"
                >clar.
              </span>
            </p>
            <div
              class="heart-wrapper animated mx-auto"
              data-aos="fade"
              data-aos-duration="500"
              data-aos-delay="3000"
              style="transition-delay: 4s;"
            >
              <div class="heart">
                <div class="tl"></div>
                <div class="tr"></div>
                <div class="bl"></div>
                <div class="br"></div>
              </div>
              <div class="ring"></div>
              <div class="circles"></div>
            </div>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">Public profile</h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Introducing public and private profiles designed around security
              and privacy.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
            <video
              class="video-player__video animatable js-video-player js-video-load anim-appear"
              preload="auto"
              loop=""
              muted=""
              autoplay=""
              playsinline=""
              tabindex="0"
            >
              <source
                data-src="https://storage.googleapis.com/spec-host-backup/mio-resources%2Fassets%2F1s0vq4AJYrI3R0aSK9UGW-VJ9AzOd-GaU%2Fgallery-sitecrop-hero-final.mp4"
                src="https://storage.googleapis.com/spec-host-backup/mio-resources%2Fassets%2F1s0vq4AJYrI3R0aSK9UGW-VJ9AzOd-GaU%2Fgallery-sitecrop-hero-final.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell red-texture grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">Public profile</h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Introducing public and private profiles designed around security
              and privacy.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Favorites: 'Favorites'
}
</script>

<style>
.red-texture {
  background: url(/img/favorites/chaos.png) 0px 0px / 300px 300px,
    linear-gradient(315deg, rgb(226, 38, 77) 0.57%, rgb(247, 77, 111) 100%) 0%
      0% / cover !important;
}
.texture {
  position: relative;
  -webkit-box-flex: 1;
  flex-grow: 1;
  padding-top: 1rem;
  padding-bottom: 1rem;
  will-change: clip-path, padding-top, padding-bottom;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  color: rgb(255, 255, 255);
  transition: clip-path 0.2s ease-out 0s, padding-top 0.2s ease-out 0s,
    padding-bottom 0.2s ease-out 0s;
  background: url(/img/favorites/chaos.png) 0px 0px / 300px 300px,
    linear-gradient(315deg, rgb(24, 13, 28) 0.57%, rgb(69, 38, 80) 100%) 0% 0% /
      cover !important;
}
.typography-phrase {
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 182px;
  margin-bottom: 107px;
  text-align: center;
}
.word {
  font-size: 56px;
  line-height: 1.07143;
  font-weight: 700;
  letter-spacing: -0.005em;
  font-family: 'SF Pro Display', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica',
    'Arial', sans-serif;
  position: relative;
}
.heart-wrapper {
  height: 30em;
  width: 30em;
  position: relative;
  cursor: pointer;
}
.heart-wrapper .heart {
  display: block;
  height: 10em;
  width: 10em;
  top: 54%;
  margin-top: -5em;
  margin-left: -5em;
  left: 50%;
  position: absolute;
  z-index: 0;
}
.heart-wrapper .heart > * {
  overflow: hidden;
  position: absolute;
}
.heart-wrapper .heart > *:after {
  display: block;
  content: '';
  position: absolute;
  background: #aab8c2;
}
.heart-wrapper .heart .tl {
  height: 25%;
  width: 50.25%;
  top: 0;
  left: 0;
}
.heart-wrapper .heart .tl:after {
  top: 0;
  left: 0;
  height: 200%;
  width: 104%;
  border-top-left-radius: 70% 80%;
  border-top-right-radius: 80% 80%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
.heart-wrapper .heart .tr {
  height: 25%;
  width: 50.25%;
  top: 0;
  right: 0;
}
.heart-wrapper .heart .tr:after {
  top: 0;
  right: 0;
  height: 200%;
  width: 104%;
  border-top-left-radius: 80% 80%;
  border-top-right-radius: 70% 80%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
.heart-wrapper .heart .bl {
  height: 75.5%;
  width: 50.25%;
  bottom: 0;
  left: 0;
}
.heart-wrapper .heart .bl:after {
  top: 0;
  left: 0;
  height: 95%;
  width: 160%;
  border-top-left-radius: 0 0;
  border-top-right-radius: 0 0;
  border-bottom-right-radius: 0 0;
  border-bottom-left-radius: 100% 100%;
}
.heart-wrapper .heart .br {
  height: 75.5%;
  width: 50.25%;
  bottom: 0;
  right: 0;
}
.heart-wrapper .heart .br:after {
  top: 0;
  right: 0;
  height: 95%;
  width: 160%;
  border-top-left-radius: 0 0;
  border-top-right-radius: 0 0;
  border-bottom-right-radius: 100% 100%;
  border-bottom-left-radius: 0 0;
}
.heart-wrapper .ring {
  display: block;
  position: absolute;
  border-width: 0;
  border-style: solid;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  z-index: 1;
}
.heart-wrapper .circles {
  display: block;
  position: absolute;
  height: 1.66667em;
  width: 1.66667em;
  top: 50%;
  left: 50%;
  margin-top: -0.83333em;
  margin-left: -0.83333em;
  z-index: 2;
  border-radius: 50%;
}
.heart-wrapper:hover .heart .tl:after,
.heart-wrapper:hover .heart .tr:after,
.heart-wrapper:hover .heart .bl:after,
.heart-wrapper:hover .heart .br:after {
  background: #e2264d;
}
.heart-wrapper.animated .heart {
  -webkit-animation-name: heart;
  animation-name: heart;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
}
.heart-wrapper.animated .heart .tl:after,
.heart-wrapper.animated .heart .tr:after,
.heart-wrapper.animated .heart .bl:after,
.heart-wrapper.animated .heart .br:after {
  background: #e2264d;
}
.heart-wrapper.animated .ring {
  -webkit-animation-name: ring;
  animation-name: ring;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
}
.heart-wrapper.animated .circles {
  -webkit-animation-name: circles;
  animation-name: circles;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
}
</style>
